import { consultFormService, consultHistoryService } from '@/_services'
import { indexedDB } from '@/_helpers'

import Vue from 'vue'

function newConsultSteps() {
  return Object.assign(
    {},
    {
      Client: {
        title: 'Client',
        visited: true,
        complete: false,
        dependsOn: [],
      },
      ClientDetails: {
        title: 'Client Details',
        visited: false,
        complete: false,
        dependsOn: [],
      },
      ContactDetails: {
        title: 'Contact Details',
        visited: false,
        complete: false,
        dependsOn: [],
      },
      AnimalNumbersSheep: {
        title: 'Animal Numbers - Sheep',
        visited: false,
        complete: false,
        dependsOn: [],
      },
      SheepReproductionPlan: {
        title: 'Sheep - Production',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      HoggetMating: {
        title: 'Hogget / Rams',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      LambProduction: {
        title: 'Lamb Production',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      SheepGeneral: {
        title: 'Sheep - General',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      AnimalNumbersBeef: {
        title: 'Animal Numbers - Beef',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      Beef: {
        title: 'Beef',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      BeefDisease: {
        title: 'Beef - Disease',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      BeefTraceElements: {
        title: 'Beef - Trace Elements',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      BeefParasiteManagement: {
        title: 'Beef - Parasite Management',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      AnimalNumbersDeer: {
        title: 'Animal Numbers - Deer',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DeerReproduction: {
        title: 'Deer Reproduction',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DeerDisease: {
        title: 'Deer disease',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DeerParasites: {
        title: 'Deer - Parasites',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DeerTraceElements: {
        title: 'Deer - Trace elements',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DeerVelveting: {
        title: 'Deer - Velveting',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      AnimalNumbersDairySupport: {
        title: 'Animal Numbers - Dairy Support',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DairySupport: {
        title: 'Dairy support',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      Dogs: {
        title: 'Dogs',
        visited: false,
        complete: false,
        requiredFields: ['dogs_vax_run'],
      },
      AnimalNumbersLifestyleOther: {
        title: 'Animal Numbers - Other / Lifestyle',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      DrugAllocations: {
        title: 'Drug allocations',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      EmailNotifications: {
        title: 'Email Notifications',
        dependsOn: [],
        visited: false,
        complete: false,
      },
      Disclaimer: {
        title: 'Disclaimer Page',
        dependsOn: ['__all__'],
        visited: false,
        complete: false,
      },
    }
  )
}

const state = {
  version: '0.9.0',
  client: null,
  currentIndex: 0,
  consultSteps: newConsultSteps(),
  sheepSteps: ['AnimalNumbersSheep', 'SheepReproductionPlan', 'HoggetMating', 'LambProduction', 'SheepGeneral'],
  beefSteps: ['AnimalNumbersBeef', 'Beef', 'BeefDisease', 'BeefTraceElements', 'BeefParasiteManagement'],
  deerSteps: [
    'AnimalNumbersDeer',
    'DeerReproduction',
    'DeerDisease',
    'DeerParasites',
    'DeerTraceElements',
    'DeerVelveting',
  ],
  dogSteps: ['Dogs'],
  lifestyleSteps: ['AnimalNumbersLifestyleOther'],
  dairysupportSteps: ['AnimalNumbersDairySupport', 'DairySupport'],
  // models: {},
  backendErrors: {},
  dbName: 'general-farm-consult',
  endpoints: {
    get: '/clients/{client}/general_farm_consult/{season}',
    post: '/clients/{client}/general_farm_consult/{season}/save',
  },
}

const actions = {
  saveConsultData({ commit, state }, { clientId, season }) {
    let endpoint = state.endpoints.post.replace('{client}', clientId).replace('{season}', season)

    return indexedDB.get(clientId, state.dbName).then((consultData) => {
      return consultFormService.saveClientConsultData(consultData.models, endpoint).catch((error) => {
        // return dispatch('addBackendErrors', {clientId: state.client, errors: error.response.data})
        if (error.response.status == 400) {
          commit('addBackendErrors', error.response.data)
        }
        return Promise.reject(error)
      })
    })
  },
  getReadOnlyData({ commit, state }, consultParams) {
    let endpoint = state.endpoints.get
      .replace('{client}', consultParams.clientId)
      .replace('{season}', consultParams.season)
    return consultHistoryService.getConsultHistoryData(endpoint).then(
      (models) => {
        commit('resetConsultSteps', newConsultSteps())
        commit('setClient', consultParams.clientId)
        commit('setModels', models)
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  },
  getConsultData({ commit, dispatch, state }, { clientId, season }) {
    return indexedDB.get(state.client, state.dbName).then((consultState) => {
      if (consultState && consultState.version === state.version) {
        commit('setModels', consultState.models)
        commit('resetConsultSteps', consultState.consultSteps)
        commit('updateStateFromIDB', consultState)
      } else {
        let endpoint = state.endpoints.get.replace('{client}', clientId).replace('{season}', season)

        return consultFormService.getClientConsultData(endpoint).then(
          (models) => {
            commit('setClient', clientId)
            commit('resetConsultSteps', newConsultSteps())
            commit('setModels', models)
            dispatch('backupState', { models })
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    })
  },
}

const mutations = {
  createAnimal(state, animalData) {
    if (state.models.ClientDetails.NEW_ANIMALS == undefined) {
      Vue.set(state.models.ClientDetails, 'NEW_ANIMALS', {})
    }

    let id = Math.max(...Object.keys(state.models.ClientDetails.NEW_ANIMALS).concat([0])) + 1

    animalData.frontend_id = Number(id)

    Vue.set(state.models.ClientDetails.NEW_ANIMALS, id, animalData)
  },
  addContact(state, contactData) {
    contactData.clientcontact_set = []

    if (!contactData.id) {
      contactData.frontend_id = Object.keys(state.models.ContactDetails.CONTACTS).length + 1
    }

    let c = Object.assign({}, contactData)
    state.models.ContactDetails.CONTACTS.push(c)
  },
  editContact(state, contactData) {
    let contacts = state.models.ContactDetails.CONTACTS

    let lookup = contactData.frontend_id ? 'frontend_id' : 'id'

    let contact = contacts.filter((c) => c[lookup] == contactData[lookup])

    if (contact) {
      Object.assign(contact[0], contactData)
    }
  },
  removeContact(state, contact) {
    let contacts = state.models.ContactDetails.CONTACTS
    let lookup = contact.frontend_id ? 'frontend_id' : 'id'

    state.models.ContactDetails.CONTACTS = contacts.filter((c) => c[lookup] != contact[lookup])
  },
}

const getters = {
  animals:
    (state, getters) =>
    (type, includeNew = false) => {
      let typesMap = {
        sheep: 'AnimalNumbersSheep',
        beef: 'AnimalNumbersBeef',
        deer: 'AnimalNumbersDeer',
        dairy_support: 'AnimalNumbersDairySupport',
      }
      return (Object.entries(state.models[typesMap[type]].ANIMALS) || [])
        .map((a) => {
          return {
            id: Number(a[0]),
            name: a[1],
            is_consult_animal: state.models.ClientDetails[`animal_${a[0]}-is_consult_animal`],
          }
        })
        .concat(includeNew ? getters.newAnimals(type) : [])
    },
  newAnimals: (state) => (type) => {
    return Object.values(state.models.ClientDetails.NEW_ANIMALS || []).filter(
      (animal) => animal.best_calc_type == (type == 'dairy_support' ? 'dairy' : type)
    )
  },
  enabledAnimals:
    (_, getters) =>
    (type, includeNew = true) => {
      return getters.animals(type, includeNew).filter((a) => a.is_consult_animal)
    },
  consultSteps: (state) => {
    if (!state.models.ClientDetails) {
      return state.consultSteps
    }
    let rejectedSteps = []
    if (!state.models.ClientDetails.is_sheep) {
      rejectedSteps = rejectedSteps.concat(state.sheepSteps)
    }
    if (!state.models.ClientDetails.is_beef) {
      rejectedSteps = rejectedSteps.concat(state.beefSteps)
    }
    if (!state.models.ClientDetails.is_deer) {
      rejectedSteps = rejectedSteps.concat(state.deerSteps)
    }
    if (!state.models.ClientDetails.is_dogs) {
      rejectedSteps = rejectedSteps.concat(state.dogSteps)
    }
    if (!state.models.ClientDetails.is_lifestyle) {
      rejectedSteps = rejectedSteps.concat(state.lifestyleSteps)
    }
    if (!state.models.ClientDetails.is_dairy_support) {
      rejectedSteps = rejectedSteps.concat(state.dairysupportSteps)
    }

    return Object.keys(state.consultSteps).reduce((filtered, stepSlug) => {
      if (!rejectedSteps.includes(stepSlug)) {
        filtered[stepSlug] = state.consultSteps[stepSlug]
      }
      return filtered
    }, {})
  },
}

export default {
  stateMixin: state,
  actionsMixin: actions,
  mutationsMixin: mutations,
  gettersMixin: getters,
}
